import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { setupApi } from "@/api";
import AppRouter from "@/router";

export default function App() {
  const navigate = useNavigate();
  const location = useLocation();
  const [ready, setReady] = useState(false);

  useEffect(() => {
    const path = location.pathname;
    if (path === "/setup" || path === "/login") {
      setReady(true);
      return;
    }
    setupApi
      .getStatus()
      .then((res) => {
        if (!res.data?.initialized) {
          navigate("/setup", { replace: true });
        }
      })
      .catch(() => navigate("/setup", { replace: true }))
      .finally(() => setReady(true));
  }, [location.pathname, navigate]);

  if (!ready) return null;

  return <AppRouter />;
}
